var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pls-wechat"},[_c('van-icon',{attrs:{"name":"info","color":"rgb(25, 137, 250)","size":"100"}}),_c('div',{staticClass:"pls-context"},[_vm._v("请在微信客户端打开链接")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }